// extracted by mini-css-extract-plugin
module.exports = {"internalLink":"style_internalLink__hWOg_","listInternalLink":"style_listInternalLink__2JIcM"};